import { render, staticRenderFns } from "./furnitureCard.vue?vue&type=template&id=02309164&"
import script from "./furnitureCard.vue?vue&type=script&lang=js&"
export * from "./furnitureCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports